import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;

  padding: 30px;
  margin-top: 30px;
`;
